import React from "react";
import Video from "./assets/video.mp4";

import {
  Usecases,
  Contact,
  FAQ,
  Backedby,
  Footer,
  Feedbacks,
  Hero,
  Navbar,
  Blogs,
  StarsCanvas,
  Product,
} from "./components";

const Home = () => {
  return (
    <>
      <div className="relative z-0  bg-primary">
        <div className="">
          <video
            autoPlay
            loop
            muted
            src={Video}
            type="video/mp4"
            className="w-full h-full absolute object-cover"
          ></video>
          <Navbar />
          <Hero />
        </div>
        <Backedby />
        <Product />
        <Usecases />
        {/* <FAQ />
        <Blogs /> */}
        {/* <Feedbacks /> */}
        <div className="relative z-0">
          <Contact />
          <StarsCanvas />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
